import { useEffect, useRef } from 'react';
import { useWalkthroughContext } from './WalkthroughProvider';
import { getTourConfig } from './tourConfigs';
import { WalkthroughButton } from './WalkthroughButton';

/**
 * Drop this component into any module section to auto-trigger
 * its walkthrough on first visit and show a permanent Help button.
 */
export function WalkthroughTrigger({ moduleId, showButton = true }) {
  const ctx = useWalkthroughContext();
  const hasTriggered = useRef(false);

  useEffect(() => {
    if (!ctx || !ctx.loaded || hasTriggered.current || ctx.activeTour) return;
    if (ctx.shouldShowTour(moduleId)) {
      const config = getTourConfig(moduleId);
      if (config) {
        hasTriggered.current = true;
        setTimeout(() => ctx.startTour(moduleId, config.steps), 800);
      }
    }
  }, [ctx?.loaded, moduleId, ctx?.activeTour]);

  // Reset trigger when moduleId changes
  useEffect(() => {
    hasTriggered.current = false;
  }, [moduleId]);

  if (!showButton) return null;
  return <WalkthroughButton moduleId={moduleId} />;
}
